import { Entity } from '@core/entities/entity'
import { plainToInstance } from 'class-transformer'
import { IPermitTemplateSummary } from './IPermitTemplateSummary'
import { PermitTemplateStatus } from '@core/entities/permit/PermitTemplate/types'

export class PermitTemplateSummary extends Entity<IPermitTemplateSummary> {
  id: number
  name: string
  code: string
  colour: string
  status: PermitTemplateStatus

  public static new(payload: unknown): PermitTemplateSummary {
    return plainToInstance(PermitTemplateSummary, payload)
  }
}
